import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import dayjs from '@/lib/dayjs';
import de from './locales/de.json';
import en from './locales/en.json';

export const supportedLanguages = ['de', 'en'] as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    fallbackLng: 'de',
    supportedLngs: supportedLanguages,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'firetracker.lang',
    },
  });

const applyLanguage = (lng: string) => {
  document.documentElement.lang = lng;
  // Datums-/Wochentagsnamen folgen der UI-Sprache (auch außerhalb des App-Layouts, z. B. Kiosk)
  dayjs.locale(lng.startsWith('en') ? 'en' : 'de');
};
i18n.on('languageChanged', applyLanguage);
if (i18n.language) applyLanguage(i18n.language);

export default i18n;
